import { Check, CheckCheck, CircleCheckBig, CircleDot, Loader, X } from "lucide-react"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export function useConversationStatuses() {
  const { t } = useTranslation()

  const labels = useMemo(
    () => ({
      Failed: t("conversations.statuses.Failed"),
      Pending: t("conversations.statuses.Pending"),
      Reached: t("conversations.statuses.Reached"),
      Opened: t("conversations.statuses.Opened"),
      Engaged: t("conversations.statuses.Engaged"),
      Achieved: t("conversations.statuses.Achieved"),
    }),
    [t],
  )

  const icons = useMemo(
    () => ({
      Failed: <X size={12} />,
      Pending: <Loader size={12} />,
      Reached: <Check size={12} />,
      Opened: <CheckCheck size={12} />,
      Engaged: <CircleDot size={12} />,
      Achieved: <CircleCheckBig className="text-success" size={12} />,
    }),
    [],
  )

  return { labels, icons }
}
